import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles = ({ theme }) => css`
  label: youtube-player;

  cursor: pointer;

  position: relative;

  &::after,
  &::before {
    content: '';

    position: absolute;
    left: 50%;
    top: 50%;

    pointer-events: none;
  }

  &::before {
    background-color: ${theme.colors.p500};
    border-radius: ${theme.borderRadius.circle};
    transform: translate(-50%, -50%);
    height: 64px;
    width: 64px;
  }

  &::after {
    border-bottom: 16px solid transparent;
    border-left: 28px solid ${theme.colors.white};
    border-top: 16px solid transparent;
    color: ${theme.colors.white};
    transform: translateY(-50%) translateX(-50%) translateX(${theme.spacings.bit});
  }
`

export const YoutubePlayer = styled('div')(baseStyles)
